// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3E317","col":"styles_col__M0D__"};